import React from "react";
import { useSearchParams } from "react-router-dom";
import {Link} from "react-router-dom";
import AuthContext from '../../store/AuthContext';
import EditDimensionMain from "./EditDimensionMain"
import EditDimensionLocations from "./EditDimensionLocations"
import EditDimensionAnalytics from "./EditDimensionAnalytics"
import EditDimensionFiles from "./EditDimensionFiles"
import EditDimensionAnchors from "./EditDimensionAnchors"
import EditDimensionMonitor from "./EditDimensionMonitor"
import DimensionsService from "../../services/DimensionsService"
import Dimension from "../../models/Dimension";
import NavigationBar from "../../components/NavigationBar"
import {Breadcrumb} from 'react-bootstrap';

enum Tab { Main, Locations, Analytics, Files, Anchors, Monitor }

function tabFromStr(str: string | null)
{
    switch(str) {
        case 'main': return Tab.Main;
        case 'locations': return Tab.Locations;
        case 'analytics': return Tab.Analytics;
        case 'files': return Tab.Files;
        case 'anchors': return Tab.Anchors;
        case 'monitor': return Tab.Monitor;
        default:
            return Tab.Main;
    }
}

function tabToStr(tab: Tab)
{
    switch(tab) {
        case Tab.Main: return 'main';
        case Tab.Locations: return 'locations';
        case Tab.Analytics: return 'analytics';
        case Tab.Files: return 'files';
        case Tab.Anchors: return 'anchors';
        case Tab.Monitor: return 'monitor';
        default:
            return null;
    }
}

const EditDimensionPage: React.FC = () => {
    const authCtx = React.useContext(AuthContext);
    const [dimension, setDimension] = React.useState<Dimension | undefined>(undefined);
    const [searchParams, setSearchParams] = useSearchParams();
    const dimId = searchParams.get("dim");

    React.useEffect(() => {
        reloadDimension();
    }, []);

    React.useEffect(() => {
        document.title=`DimensionX Studio | ${dimension ? dimension.name : "Dimension"}`;
    }, [dimension]);

    const [tab, setTab] = React.useState<Tab>(tabFromStr(searchParams.get("tab")));

    function reloadDimension() {
        if (dimId) {
            DimensionsService.getDimension('dev', dimId!)
                .then(dim => setDimension(dim))
                .catch(err => console.error(`Failed to get dimension [${dimId}]: ${err}`));
        }
    }

    if (!dimension) {
        return (<p>Loading..</p>);
    }

    return (
        <>
            <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/own-dimensions" }}>
                    Your Dimensions
                </Breadcrumb.Item>
                <Breadcrumb.Item active>
                    {dimension.name}
                </Breadcrumb.Item>
            </Breadcrumb>
            <NavigationBar
                items={[{value: Tab.Main, text: "Main"},
                        {value: Tab.Locations, text: "Locations"},
                        {value: Tab.Analytics, text: "Analytics", large_only: true},
                        {value: Tab.Files, text: "Files"},
                        {value: Tab.Anchors, text: "Anchors"},
                        {value: Tab.Monitor, text: "Health Monitor", large_only: true}]}
                active={tab}
                onChange={(item: Tab) => {
                    setTab(item);
                    //searchParams.set('tab', tabToStr(item)); // doesn't work
                    //setSearchParams({tab: tabToStr(item)}); // overwrites other params
                }}
            />

                {tab == Tab.Main && (<EditDimensionMain data={dimension}/>)}
                {tab == Tab.Locations && (<EditDimensionLocations data={dimension} reloadDimension={reloadDimension}/>)}
                {tab == Tab.Analytics && (<EditDimensionAnalytics data={dimension}/>)}
                {tab == Tab.Files && (<EditDimensionFiles dimension={dimension!}/>)}
                {tab == Tab.Anchors && (<EditDimensionAnchors data={dimension}/>)}
                {tab == Tab.Monitor && (<EditDimensionMonitor dimension={dimension}/>)}
        </>
    );
};

export default EditDimensionPage;
